import type { UebersetzungNameBeschreibung } from '../components/uebersetzungen-edit-name-beschreibung/uebersetzungen-edit-name-beschreibung';
import { SUPPORTED_LANGUAGES } from './supported-language.function';

/**
 * An empty name and Beschreibung per supported language, the skeleton a loaded entry is merged onto
 * and the start of a new one in the translations editor.
 *
 * @returns {UebersetzungNameBeschreibung[]} One empty translation per language
 */
export function buildBlankUebersetzungen(): UebersetzungNameBeschreibung[] {
  return SUPPORTED_LANGUAGES.map((spracheLokalisierung) => ({ spracheLokalisierung, name: '', beschreibung: '', hasValues: false }));
}
